// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__aR6LL","content":"GlobalSearch_content__4qIUu"};